import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.verify', {
        url: '/verify',
        component: 'companyUserDirectoriesManageAccountVerify',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/verify/verify-account-owner.state.js